import React, {Component} from 'react';
import scrollToComponent from 'react-scroll-to-component';
import Smile from '../smile';
import PropTypes from 'prop-types';
import smileSuper from './smile-super.svg';
import smileGood from './smile-good.svg';
import smileFail from './smile-fail.svg';
import './smiles.css';


export const SMILE_SUPER = 'super';
export const SMILE_GOOD = 'dobré';
export const SMILE_FAIL = 'je co zlepšit';

class Smiles extends Component {

    constructor(props) {
        super(props);
        this.myRef = React.createRef();
    }

    scrollToAnchor = () => {
        scrollToComponent(this.myRef.current, {
            offset: 16,
            align: 'top',
            duration: 1000
        });
    }

    getNameFromMark() {
        let name;
        switch(this.props.mark) {
            case 1:
                name = SMILE_SUPER;
                break;

            case 2:
                name = SMILE_GOOD;
                break;

            case 3:
                name = SMILE_FAIL;
                break;

            default:
                name = undefined;
        }

        return name;
    }

    render() {

        let text;

        if(this.props.mark !== null) {
            text = <div className="Smiles__text">
                <span className="Smiles__text__top">{`Vybrali jste hodnocení ${this.getNameFromMark()}, děkujeme za Váš názor. `}</span>
                <span className="Smiles__text__bottom">{`Pomůžete nám se zlepšit ohodnocením těchto ${this.props.questionsCount} oblastí?`}</span>
                <div className="Smiles__text__arrow"  ref={this.myRef} onClick={this.scrollToAnchor}></div>
            </div>;
        } else {
            text = <div className="Smiles__text">
                <span className="Smiles__text__top">{`Nejprve prosím zvolte hodnocení pomocí smaijlíků.`}</span>
            </div>;
        }

        return (
            <div className="Smiles">
                <div className="Smiles__icons">
                    <div className="Smiles__icons__wrap">
                            <div className="Smiles__icons__i">
                               <Smile
                                   text={'Super'}
                                   mark={1}
                                   type={SMILE_SUPER}
                                   isActive={(this.props.mark===1)}
                                   onClick={this.props.voteMark}
                                   image={smileSuper}
                               />
                            </div>
                            <div className="Smiles__icons__i">
                               <Smile
                                   text={'Dobře, ale..'}
                                   mark={2}
                                   type={SMILE_GOOD}
                                   isActive={(this.props.mark===2)}
                                   onClick={this.props.voteMark}
                                   image={smileGood}
                               />
                            </div>
                            <div className="Smiles__icons__i">
                               <Smile
                                   text={'Je co zlepšit'}
                                   mark={3}
                                   type={SMILE_FAIL}
                                   isActive={(this.props.mark===3)}
                                   onClick={this.props.voteMark}
                                   image={smileFail}
                               />
                            </div>
                    </div>
                </div>
                {text}
            </div>
        );
    }

}

Smiles.propTypes = {
    mark: PropTypes.oneOf([null, 1, 2, 3]),
    voteMark: PropTypes.func.isRequired,
    questionsCount: PropTypes.number.isRequired,
};

export default Smiles;


// WEBPACK FOOTER //
// ./src/components/smiles/index.js